import { MeterTypeService } from '@/http-services/meter-type.service';
import { UtilityFamily } from '@ncss/models/dist/v3';
import { until, useAsyncState } from '@vueuse/core';
import { computed, watch } from 'vue';

export function useMeterModels(
  getUtility: () => UtilityFamily | undefined | null,
  getManufacturerId: () => number | undefined | null
) {
  const meterTypes = new MeterTypeService();
  const utilityFamily = computed(getUtility);
  const manufacturerId = computed(getManufacturerId);

  const {
    state: all,
    isLoading,
    isReady,
    execute: refresh,
  } = useAsyncState(async () => {
    const family = utilityFamily.value;
    const manId = manufacturerId.value;
    if (family !== undefined && family !== null && !!manId) {
      const docs = await meterTypes.getMeterTypes(manId, family);
      return docs;
    }
    return [];
  }, []);

  async function search(text?: string) {
    await until(isReady).toBe(true);
    if (text) {
      return all.value?.filter((m) => m.meterModelNumber?.toLowerCase()?.includes(text.toLowerCase()));
    } else {
      return all.value;
    }
  }

  async function findById(id: number) {
    await until(isReady).toBe(true);
    return all.value?.find((m) => m.meterTypeId === id);
  }

  watch([utilityFamily, manufacturerId], () => refresh(), { immediate: true });
  return { all, isLoading, isReady, search, findById };
}
